import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0dbc168c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0dbc168c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbc168c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dbc168c')) {
      api.createRecord('0dbc168c', component.options)
    } else {
      api.reload('0dbc168c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0dbc168c&scoped=true", function () {
      api.rerender('0dbc168c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Activities/Card/index.vue"
export default component.exports